<ng-container [ngSwitch]="view">
  <div *ngSwitchCase="'policy'" class="loader--policy">
    <div class="loader--policy_center">
      <div class="loader--policy_animation nx-margin-bottom-s">
        <nx-icon name="product-plane" size="l" class="loader--policy_icon"></nx-icon>
      </div>
      <p nxCopytext="large">
        <b>
          {{ 'loader.policy.content' | translate }}
        </b>
      </p>
    </div>
    <div class="loader--policy_illustration">
      <qbe-illustration name="womanOnComputerWithInformation"></qbe-illustration>
    </div>
  </div>
  <div *ngSwitchDefault class="loader" [ngClass]="view">
    <nx-spinner size="large"></nx-spinner>
  </div>
</ng-container>
